module.exports = __webpack_public_path__ + "static/media/goldenprizeth-tuna-springwater-lid.af7408f2.png";